import { theme } from "../../theme";

export const eventInfoStyles = {
    wrapper: {},
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent:"space-between",
    },
    headerLeft:
      {display:"flex",maxWidth:"80%"}
    ,
    eventName:{
      margin: "auto",
      fontSize: 45,
    },
    saveBtn:{
      marginBottom: "10px",
      "&.notSaved":{
        color:  "#fff !important",
        backgroundColor:`${theme.palette.grey["700"]} !important`
      },
      "&.saved":{

        color:  "primary",
        backgroundColor: "",
      }

    },
    content: {
      paddingTop: "15px",
    },
    footer: {
      position: "relative",
      paddingLeft: "25px",
    },
    eventLogo: {
      width: "70px",
      height: "70px",
      maxWidth: "70px",
      minWidth: "70px",
      maxHeight: "70px",
      minHeight: "70px",
      position: "relative",
      marginRight: "25px",
      display:"flex",
      alignItems:"center",
      background: "#fff",
      borderRadius: "50%",
      border: "1px solid #E7E7E7",
      filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.05))",
    },
    disabledButton: {
      color: "#fff !important",
      backgroundColor: `${theme.palette.grey["700"]} !important`,
    },
    textField: {},
    textFieldWithAdornment: {
      "& .input": {
        padding: "6px 30px 6px 7px",
      },
    },
    selectField: {},
    inputIcon: {
      position: "absolute",
      right: "7px",
      top: "50%",
      fontSize: "18px",
      color: theme.palette.grey["800"],
    },
    infoIcon: {
      position: "absolute",
      left: 0,
      top: "3px",
      fontSize: "14px",
      color: "#F6A316",
    },
    allFields:{
      "& .MuiFormControl-root": {
        m: 0,
      },
      "& .MuiInputBase-root": {
        m: 0,
      },
      "& .MuiFormHelperText-root ": {
        mx: 0,
      },
    }
  };
  
  export const eventInfoCustomStyle = {
    "&.noPastErrorStyle .Mui-error":{
      color:theme.palette.text.primary,
    },
    "&.noPastErrorStyle .Mui-error.MuiFormHelperText-root ":{
      color:theme.palette.error.main,
    },
    "& .MuiButtonBase-root ": {
      "& svg": {
        height: "18px",
        width: "18px",
        color: "#A8A8A8",
      },
    },
  };